import Form from 'components/Base/Form';
import { FormField } from 'components/Base/Form/FormItem';
import { loginEmailFields } from 'pages/public/Login/data/forms';
import { EFormIds, TLoginEmailFormProps } from 'pages/public/Login/Login.types';

const SignForm = ({
  form,
  userCredential = { email: null, password: null },
}: TLoginEmailFormProps) => {
  return (
    <Form
      form={form}
      name="basic"
      autoComplete="off"
      id={EFormIds.EMAIL_LOGIN}
      initialValues={userCredential}
    >
      {Object.keys(loginEmailFields).map(field => (
        <FormField key={field} name={field} {...loginEmailFields[field]} />
      ))}
    </Form>
  );
};

export default SignForm;
